/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const reserveTableSchema = z.object({
	id: z.uuid(),
	number: z.int().min(0).max(2147483647),
	name: z.string().max(100).optional(),
	seating_capacity: z.int().min(0).max(2147483647).optional(),
	can_be_reserved: z.boolean().optional(),
});
